import styled from "styled-components";

export const VenueLoginSelectWrapper = styled.div`
  .ant-select {
    width: 100%;
  }
`;
